// Self Exclusion
import { ResponsibleApi } from '@atlas/core';
import { getSelfRegulationFormattedFields } from 'utils';
import { handleFormSubmit } from 'common/utils/form';

// Self regulation Loss Limits
export const onSetLostLimitsSubmit = async (formData, actions, spentType) =>
  handleFormSubmit(
    ResponsibleApi.setClientLossLimits.bind(ResponsibleApi),
    getSelfRegulationFormattedFields.bind(null, spentType),
  )(formData, actions);

// Self regulation Deposit limits
export const onSetDepositLimitsSubmit = handleFormSubmit(
  ResponsibleApi.setClientDepositLimits.bind(ResponsibleApi),
  getSelfRegulationFormattedFields.bind(null, null),
);
